/* eslint-disable */
import {AccordionActions, Button as ButtonMat, createStyles, Divider, Theme, withStyles,} from "@material-ui/core";
import {
  addHTMLTemplates,
  addJSONTemplates,
  getAllFunds,
  getBSTemplateList,
  getFund,
  getTemplateByName,
} from "../../../utils/store/actions/funds.actions";
import {FormControl, FormLabel, HStack, Select} from "@chakra-ui/react";
import {withTranslation} from "react-i18next";
import List from "@material-ui/core/List";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {DropzoneArea} from "material-ui-dropzone";
import React, {Component} from "react";
import {connect} from "react-redux";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import {getEnums} from "../../../utils/store/actions/survey.action";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
    dropzone: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    dropzoneEmail: {},
    previewChip: {
      maxWidth: "300px",
      color: "#ae0064",
    },
  });
class BsTemplates extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      party: "",
    };
  }
  async componentDidMount() {
    await this.props.getAllFunds("false");
    await this.props.getEnums();
  }
  // GET BS TEMPLATES
  selectChangeFund = (e: any) => {
    const fund = this.props.Funds?.funds_list.find(
      (f: any) => f.id === e.target.value
    );
    const fundId = fund.person.id;
    this.props.getFund(fundId);
    this.setState({
      fund: e.target.value,
    });
  };
  selectChangePart = (e: any) => {
    this.setState({ partId: e.target.value });
    this.props.getBSTemplateList(e.target.value);
  };

  // DOWNLOAD BS TEMPLATES
  downloadTemplates = (templateName: string) => {
    this.props.getTemplateByName(this.state.partId, templateName).then(() => {
      let filename = templateName;
      var element = document.createElement("a");
      let splitFilename = filename.split(".");
      let newFilename: any = "";
      if (splitFilename[splitFilename.length - 1] === "json") {
        newFilename = JSON.stringify(this.props.Funds.template_by_name);
      } else {
        newFilename = this.props.Funds.template_by_name;
      }
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(newFilename)
      );
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    });
  };

  // UPLOAD BS TEMPLATES
  handleChangeBS(bsTemplates: any) {
    this.setState({
      bsTemplates,
    });
    bsTemplates.map((template: any) => {
      if (template.type === "text/html") {
        const file: any = new FormData();
        file.append("file", template);
        this.setState({
          htmlTemplates: file,
        });
      } else {
        const file: any = new FormData();
        file.append("file", template);
        this.setState({
          jsonTemplates: file,
        });
      }
    });
  }

  uploadBS() {
    this.state.bsTemplates.map((template: any) => {
      if (template.type === "text/html") {
        this.props.addHTMLTemplates(
          this.state.partId,
          this.state.htmlTemplates
        );
      } else {
        this.props.addJSONTemplates(
          this.state.partId,
          this.state.jsonTemplates
        );
      }
    });
  }

  render() {
    const { classes, Funds, t } = this.props;
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="bsTemplatesContainer"
        >
          <Typography className={classes.heading}>
            {t("BS_TEMPLATES")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List>
            <FormControl id="fund" isRequired>
              <FormLabel>{t("FUNDS_TITLE")}</FormLabel>
              <HStack style={{ marginBottom: "5px" }}>
                <Select
                  onChange={this.selectChangeFund}
                  id="funds"
                  placeholder={t("SELECT_FUND")}
                >
                  {Funds?.funds_list &&
                    Funds?.funds_list?.length > 0 &&
                    Funds.funds_list.map((f: any) => (
                      <option key={f.id} value={f.id}>
                        {f.name}
                      </option>
                    ))}
                </Select>
              </HStack>
            </FormControl>
          </List>
          <List>
            {Funds?.fund.parts?.length > 0 && (
              <FormControl id="part" isRequired>
                <FormLabel>{t("PARTS")}</FormLabel>
                <HStack style={{ marginBottom: "5px", marginLeft: "5px" }}>
                  <Select
                    onChange={this.selectChangePart}
                    id="parts"
                    placeholder={t("SELECT_PART")}
                  >
                    {Funds.fund.parts.map((p: any) => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </Select>
                </HStack>
              </FormControl>
            )}
          </List>
        </AccordionDetails>
        <Typography className={classes.heading} style={{ margin: "20px" }}>
          {t("BS_TEMPLATES_TO_DOWNLOAD")}
        </Typography>
        <div style={{ margin: "20px" }}>
          {this.props.Funds?.bs_templates &&
            this.props.Funds.bs_templates.map((template: any) => {
              return (
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => this.downloadTemplates(template)}
                >
                  <FiberManualRecordIcon
                    style={{
                      display: "flex",
                      fontSize: "8px",
                      color: "ae0064",
                    }}
                  />
                  <li>{template}</li>
                </div>
              );
            })}
        </div>
        {this.state.fund && this.state.partId && (
          <>
            <AccordionDetails
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <DropzoneArea
                dropzoneClass={classes.dropzone}
                showFileNames
                showPreviews={true}
                showPreviewsInDropzone={false}
                useChipsForPreview
                acceptedFiles={["text/html", "application/json"]}
                previewGridProps={{
                  container: { spacing: 1, direction: "column" },
                }}
                previewChipProps={{ classes: { root: classes.previewChip } }}
                previewText="File:"
                dropzoneText={t("UPLOAD")}
                filesLimit={2}
                onChange={this.handleChangeBS.bind(this)}
              />
            </AccordionDetails>
            <Divider />
            <AccordionActions>
              <ButtonMat
                size="small"
                style={{ color: "#ae0064" }}
                onClick={() => {
                  this.uploadBS();
                }}
              >
                {t("SAVE")}
              </ButtonMat>
            </AccordionActions>
          </>
        )}
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllFunds,
  getFund,
  getEnums,
  getBSTemplateList,
  getTemplateByName,
  addHTMLTemplates,
  addJSONTemplates
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(BsTemplates)));
